import { PATIENT_TERM, PATIENT_TERM_PLURAL } from "../../config/constants";

// js file so imports to cypress work
export const addNewDevicePageTitle = "Add new device";
export const editDevicePageTitle = "Edit existing device";
export const manageUserPageTitle = "Manage users";
export const identityVerificationPageTitle =
  "Verify/edit organization identity";
export const orgAccessPageTitle = "Access organization account";
export const addOrgAdminPageTitle = "Add organization admin";
export const escalationPageTitle = `Escalate to engineering`;

export const orgFacilityColumnTitle = "Organizations & facilities";
export const devicesColumnTitle = "Devices";
export const usersAndPatientsColumnTitle = `Users & ${PATIENT_TERM_PLURAL}`;

export const manageFacility = "Manage facility";
export const unarchivePatientTitle = `Unarchive ${PATIENT_TERM}`;
